import http from "./http.service";



//  simulate/payment-intent
export const createPaymentIntent = async (payload: any) => {
    return http.post(`/simulate/payment-intent`, payload);
}

